const handleJson = (json: any): any => {
  try {
    return JSON.parse(json);
  } catch (error) {
    return json;
  }
};

export default handleJson;
